import InfoCollection from '@/components/PowerKitPreSale/components/PreOrder/infocollection';
import SuccessDialog from '@/components/PowerKitPreSale/components/PreOrder/successDialog';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import PayPalIcon from '@/components/UI/svg/Icons/PayPalIcon';
import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { memo, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { INSTALL_DES_COUNTRY, InstallQuestionModal } from '../Step456';
import css from './index.module.scss';
// import { bundleImgs } from '../Step456/products'
import { toMM100GetQuote } from '@/components/PowerKitPreSale/components/PreOrder/InfoQuote/utils';

const defaultData = {
    power: {
        title: '5Kwh Power Kits',
        tag: 'Ultimate',
        details: [
            {
                id: 1,
                img: '/img/river/river-pro_uk.png',
                title: 'ECOFLOW Power Hub \n5Kwh LFP Battery \nCable Pack',
                originalPrice: 2079,
                discountPrice: 1999,
                unit: '$',
            },
        ],
    },
    combo: {
        details: [
            {
                id: 11,
                img: '/img/river/river-pro_uk.png',
                title: 'Distribution Panel',
                originalPrice: 2079,
                discountPrice: 1999,
                unit: '$',
            },
            {
                id: 12,
                img: '/img/river/river-pro_uk.png',
                title: 'Distribution Panel',
                originalPrice: 2079,
                discountPrice: 1999,
                unit: '$',
            },
            {
                id: 13,
                img: '/img/river/river-pro_uk.png',
                title: 'Distribution Panel',
                originalPrice: 2079,
                discountPrice: 1999,
                unit: '$',
            },
        ],
    },
    solar: {
        details: [
            {
                id: 123,
                img: '/img/river/river-pro_uk.png',
                title: '300W Grid',
                originalPrice: 2079,
                discountPrice: 1999,
                unit: '$',
            },
        ],
    },
};

function Child({ data = defaultData, callBack, staticData }: any) {
    const { useLang, useRouter, useState, useEffect, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const [swiperImgs, setSwiperImgs] = useState([]);
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const { bundleImgs, comboPrice, taxPriceTag, isPriveReverseFlag, wire, installTerms } = staticData;
    const [installQuestionVisible, setInstallQuestionVisible] = useState(false);
    const [showDetailsModal_CN, setShowDetailsModal_CN] = useState(false);
    const [hasCookieFooter, setHasCookieFooter] = useState(false);
    const [cookieFooterH, setCookieFooterH] = useState(0);

    const installSpecialSites = ['us', 'ca'];
    const activityIdMap: any = {
        us: '3',
        eu: '5',
        ca: '4',
        au: '11',
        uk: '6',
        kr: '10',
        de: '7',
        fr: '8',
        jp: '9',
        cn: '12',
        it: '54',
        es: '53',
    };
    const [showInfoCollection, setShowInfoCollection] = useState(false);
    const [showInfoSuccess, setShowInfoSuccess] = useState(false);
    const collectInfoCb = ({ status }: any) => {
        if (status === 'success') {
            setShowInfoCollection(false);
            setShowInfoSuccess(true);
        }
        switch (status) {
            case 'success':
                setShowInfoCollection(false);
                setShowInfoSuccess(true);
                break;
            case 'close':
                setShowInfoCollection(false);
                break;
        }
    };

    useEffect(() => {
        const arr: any = [];
        if (data?.selectedPower) {
            arr.push({
                img: `/img/calculators/mm100/${bundleImgs[data?.bundle]}`,
                name: data?.selectedPower?.name,
            });
        }
        arr.push({ img: '/img/calculators/mm100/wire.jpg', name: wire?.name });
        if (data?.selectedCombo && data?.selectedCombo?.productId !== 0) {
            data?.selectedCombo?.subs?.map((sub: any) =>
                arr.push({
                    img: sub?.img,
                    name: sub?.name,
                }),
            );
        }
        data?.solarOptions?.map((solar: any) => {
            if (solar?.number > 0) {
                arr.push({ img: solar?.img, name: solar?.name });
            }
        });
        setSwiperImgs(arr);
    }, [data]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setHasCookieFooter(entry.isIntersecting);
                },
                { threshold: 0.5 },
            );

            const kaamelAlertBigNew = document.querySelector('#kaamelAlertBigNew') as HTMLDivElement;
            if (kaamelAlertBigNew) {
                observer.observe(kaamelAlertBigNew);
            }

            return () => {
                observer.disconnect();
            };
        }
    }, []);

    useEffect(() => {
        const kaamelAlertBigNew = document.querySelector('#kaamelAlertBigNew') as HTMLDivElement;
        setCookieFooterH(hasCookieFooter ? kaamelAlertBigNew?.offsetHeight : 0);
    }, [hasCookieFooter]);

    const onTryAgain = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator5',
            step: 'result',
            product_name: 'Ecoflow Power Kits',
            price: (data?.selectedPower?.unit || '') + data.totalDiscount,
            button_name: 'Try Again',
        });
        callBack({}, true);
    };

    const onCheckout = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator5',
                step: 'result',
                product_name: 'Ecoflow Power Kits',
                price: (data?.selectedPower?.unit || '') + data.totalDiscount,
                button_name: 'Checkout',
            });
            window?.fbq && window?.fbq('track', 'SubmitApplication');
        } catch (e) {
            console.log(e);
        } finally {
            if (locale !== 'cn') {
                // onTryAgain()
                let fragLink = '';
                data?.solarOptions
                    ?.filter((solar: any) => solar?.number > 0)
                    ?.map((option: any) => {
                        fragLink += `,${option?.variantId}:${option?.number}`;
                    });
                if (data?.selectedInstall?.variantId) {
                    fragLink += `,${data?.selectedInstall?.variantId}:1`;
                }
                fragLink += '?channel=buy_button';
                // fragLink += process.env.NODE_ENV === 'production' ? '' : '?channel=buy_button'
                return window.open(`https://${locale}.ecoflow.com/cart/${data?.bundle}:1${fragLink}`, '_blank');
            } else {
                return setShowDetailsModal_CN(true);
            }
        }
    };

    const getCartUrl = useCallback(() => {
        let fragLink = '';
        data?.solarOptions
            ?.filter((solar: any) => solar?.number > 0)
            ?.map((option: any) => {
                fragLink += `,${option?.variantId}:${option?.number}`;
            });
        if (data?.selectedInstall?.variantId) {
            fragLink += `,${data?.selectedInstall?.variantId}:1`;
        }
        fragLink += '?channel=buy_button';
        return `https://${locale}.ecoflow.com/cart/${data?.bundle}:1${fragLink}`;
    }, [data]);

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active) {
            swiper?.slideTo(index);
        }
    };

    const renderItem = (item: any, k: string, type = 'power') => {
        return (
            <div className="info-item" key={k}>
                <div className="info-item-img">
                    <Image src={item?.img} layout="fill" className="fullIImgs" alt={item?.title} aria-label={item?.title} />
                </div>
                <div className="info-item-text">
                    <p className="text-title">
                        {item?.name}
                        <span className="count">x{item?.number || 1}</span>
                    </p>
                    {locale !== 'cn' && (
                        <div className="priceBox">
                            <span className="discountPrice">
                                {!isPriveReverseFlag && `${item?.unit} `}
                                {FormatMoney(item?.discountPrice, isPriveReverseFlag ? ' ' : ',')}
                                {isPriveReverseFlag && ` ${item?.unit}`}
                                {taxPriceTag[locale] || ''}
                            </span>
                            {item?.discountPrice !== item?.originalPrice && (
                                <span className="originalPrice">
                                    {!isPriveReverseFlag && `${item?.unit} `}
                                    {FormatMoney(item?.originalPrice, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${item?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </span>
                            )}
                        </div>
                    )}
                    {locale === 'cn' && (
                        <div className="priceBox">
                            <span className="discountPrice">{t('calculators.mm100.step4.inquiry')}</span>
                        </div>
                    )}
                    {item?.discountPrice !== item?.originalPrice && locale !== 'cn' && (
                        <p className="savePrice">
                            {t('calculators.mm100.step7.save')} {!isPriveReverseFlag && `${item?.unit} `}
                            {FormatMoney((item?.originalPrice * 1000 - item?.discountPrice * 1000) / 1000, isPriveReverseFlag ? ' ' : ',')}
                            {isPriveReverseFlag && ` ${item?.unit}`}
                            {taxPriceTag[locale] || ''}
                        </p>
                    )}
                    {item?.freeShip === 1 && <div className="free-ship">{t('calculators.mm100.step4.free_shiping')}</div>}
                </div>
            </div>
        );
    };

    const openQoute = () => {
        if (['us', 'ca'].includes(locale)) toMM100GetQuote(locale);
        else setShowInfoCollection(true);
    };

    return (
        <div className={`step7 step ${css.step7}`}>
            <p className="step7-title">
                {t('calculators.mm100.step7.title')}
                <div className="title-icon">
                    <Image
                        src="/icons/icon_recommend.svg"
                        className="fullImgs"
                        layout="fill"
                        alt={t('calculators.mm100.step7.title')}
                        aria-label={t('calculators.mm100.step7.title')}
                    />
                </div>
            </p>
            <div className="mainBox">
                <div className="leftBox">
                    <Swiper
                        className={`m100-preview-swiper ${swiperImgs?.length === 1 ? 'single' : ''}`}
                        initialSlide={0}
                        preloadImages={false}
                        lazy={true}
                        centeredSlides={true}
                        grabCursor={true}
                        navigation={true}
                        onSwiper={(swiper: any) => setSwiper(swiper)}
                        onSlideChange={(swiper: any) => setActive(swiper?.activeIndex)}
                    >
                        {swiperImgs?.map((item: any, k: number) => (
                            <SwiperSlide key={k}>
                                <Image
                                    className="step7-swiper-item-img fullImgs"
                                    src={item?.img || '/img/search/error.png'}
                                    width={631}
                                    height={631}
                                    alt={item?.name}
                                    aria-label={item?.name}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    {swiperImgs?.length > 1 && (
                        <div className="pagenationImgs">
                            <ul className="step7-smallImgs" style={{ width: `${68 * swiperImgs?.length - 20}px` }}>
                                {swiperImgs?.map((img: any, k: number) => (
                                    <li className={`step7-smallImg ${k === active ? 'active' : ''}`} key={k} onClick={() => onSwiperSlideTo(k)}>
                                        <div className="img-box">
                                            <Image src={img?.img} className="fullImgs" layout="fill" alt={img?.name} aria-label={img?.name} />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
                <div className="rightBox">
                    <div className="powerBox contentBox">
                        <p className="info-title power-title">{data?.selectedPower?.productName}</p>
                        {locale !== 'jp' && <span className="tag">{t('calculators.mm100.step7.ultimate')}</span>}
                        {renderItem(data?.selectedPower, data?.selectedPower?.productId)}
                    </div>
                    {installSpecialSites.includes(locale) && (
                        <div className="installBox contentBox specailInstallBox">
                            <p className="info-title install-title">{t('calculators.mm100.step4.installation')}</p>
                            <li className="install-item">
                                <p className="install-text">{t(`calculators.mm100.step4.${data?.selectedInstall?.i18n}`)}</p>
                                <p className="install-des">
                                    {t.rich(`calculators.mm100.step4.${data?.selectedInstall?.i18n_des}`, {
                                        line: (text: any) => (
                                            <Link href="/support/videos" className="install-link" newWin>
                                                {text}
                                            </Link>
                                        ),
                                    })}
                                </p>
                                {data?.selectedInstall?.i18n_des && (
                                    <div className="install-desc">
                                        {locale !== 'us' && t(`calculators.mm100.step4.${data?.selectedInstall?.i18n_des}`)}
                                        {INSTALL_DES_COUNTRY.includes(locale) && (
                                            <span
                                                className="question"
                                                onMouseEnter={() => setInstallQuestionVisible(true)}
                                                onMouseLeave={() => setInstallQuestionVisible(false)}
                                            >
                                                <Image
                                                    src={'/img/calculators/mm100/question-mark.svg'}
                                                    layout="fill"
                                                    className="fullImgs"
                                                    alt={t('calculators.mm100.step4.questionMark')}
                                                    aria-label={t('calculators.mm100.step4.questionMark')}
                                                />
                                                {installQuestionVisible && (
                                                    <div className="installModal">
                                                        <InstallQuestionModal terms={installTerms} />
                                                    </div>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <span className="number">x1</span>
                            </li>
                            <div className="quoteBox">
                                {t.rich('calculators.mm100.step4.quote', {
                                    line: (text: string) => (
                                        <span className="quoteLink" onClick={() => openQoute()}>
                                            {text}
                                        </span>
                                    ),
                                })}
                                {locale === 'us' && (
                                    <Link className="quoteLink" href="/where-to-buy">
                                        {t('calculators.mm100.step4.nearby')}
                                    </Link>
                                )}
                            </div>
                        </div>
                    )}
                    {data?.selectedCombo && data?.selectedCombo?.productId !== 0 && (
                        <div className="comboBox contentBox">
                            <p className="info-title combo-title">{t('calculators.mm100.step7.combo')}</p>
                            <div className="combo-item">
                                <p className="combo-item-title">{data?.selectedCombo?.name}</p>
                                <div className="priceBox">
                                    {locale !== 'cn' && (
                                        <span className="discountPrice">
                                            {!isPriveReverseFlag && `${data?.selectedCombo?.unit} `}
                                            {FormatMoney(
                                                comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId],
                                                isPriveReverseFlag ? ' ' : ',',
                                            )}
                                            {isPriveReverseFlag && ` ${data?.selectedCombo?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </span>
                                    )}
                                    {locale === 'cn' && <span className="discountPrice">{t('calculators.mm100.step4.inquiry')}</span>}
                                    {comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId] !==
                                        comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId] &&
                                        locale !== 'cn' && (
                                            <span className="originalPrice">
                                                {!isPriveReverseFlag && `${data?.selectedCombo?.unit} `}
                                                {FormatMoney(
                                                    comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId],
                                                    isPriveReverseFlag ? ' ' : ',',
                                                )}
                                                {isPriveReverseFlag && ` ${data?.selectedCombo?.unit}`}
                                                {taxPriceTag[locale] || ''}
                                            </span>
                                        )}
                                    <span className="number">x1</span>
                                </div>
                                {comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId] !==
                                    comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId] &&
                                    locale !== 'cn' && (
                                        <p className="savePrice">
                                            {t('calculators.mm100.step7.save')} {!isPriveReverseFlag && `${data?.selectedCombo?.unit} `}
                                            {FormatMoney(
                                                Math.round(
                                                    100 * comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId] -
                                                        100 * comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId],
                                                ) / 100,
                                                isPriveReverseFlag ? ' ' : ',',
                                            )}
                                            {isPriveReverseFlag && ` ${data?.selectedCombo?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </p>
                                    )}
                                {data?.selectedCombo?.subs?.length > 0 && (
                                    <ul className="combo-item-subs">
                                        {data?.selectedCombo?.subs?.map((sub: any, index: number) => (
                                            <li className="combo-item-sub" key={index}>
                                                <div className="combo-item-sub-img">
                                                    <Image src={sub?.img} layout="fill" className="fullImgs" alt={sub?.title} aria-label={sub?.title} />
                                                </div>
                                                <div className="combo-item-sub-text">
                                                    <div className="title">{sub?.name}</div>
                                                    <div className="number">x1</div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    )}
                    {data?.solarOptions?.some((solar: any) => solar?.number > 0) && (
                        <div className="solarBox contentBox">
                            <p className="info-title solar-title">{t('calculators.mm100.step7.solar')}</p>
                            {data?.solarOptions
                                ?.filter((solar: any) => solar?.number > 0)
                                ?.map((option: any) => renderItem(option, option?.productId, 'solar'))}
                        </div>
                    )}
                    {locale !== 'jp' && data?.selectedInstall?.variantId !== 0 && !installSpecialSites.includes(locale) && (
                        <div className="installBox contentBox">
                            <p className="info-title install-title">{t('calculators.mm100.step4.installation')}</p>
                            <li className="install-item">
                                <p className="install-text">{t(`calculators.mm100.step4.${data?.selectedInstall?.i18n}`)}</p>
                                {data?.selectedInstall?.i18n_des && (
                                    <div className="install-desc">
                                        {locale !== 'us' && t(`calculators.mm100.step4.${data?.selectedInstall?.i18n_des}`)}
                                        {INSTALL_DES_COUNTRY.includes(locale) && (
                                            <span
                                                className="question"
                                                onMouseEnter={() => setInstallQuestionVisible(true)}
                                                onMouseLeave={() => setInstallQuestionVisible(false)}
                                            >
                                                <Image
                                                    src={'/img/calculators/mm100/question-mark.svg'}
                                                    layout="fill"
                                                    className="fullImgs"
                                                    alt={t('calculators.mm100.step4.questionMark')}
                                                    aria-label={t('calculators.mm100.step4.questionMark')}
                                                />
                                                {installQuestionVisible && (
                                                    <div className="installModal">
                                                        <InstallQuestionModal terms={installTerms} />
                                                    </div>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <span className="number">x1</span>
                            </li>
                        </div>
                    )}
                    <div className="tryAgainBtn" onClick={onTryAgain}>
                        {t('calculators.mm100.step7.try-again')}
                    </div>
                </div>
            </div>
            {/* <div className="calculatorMm100-btnsArea">
                <PrevNextBtns
                    canNext={true}
                    onBack={onTryAgain}
                    onNext={onCheckout}
                    onBackText={t('calculators.mm100.step7.try-again')}
                    onNextText={t('calculators.mm100.step7.checkout')}
                />
            </div> */}
            {/* checkout footer */}
            <div className="fixedFooter" style={{ bottom: `${cookieFooterH}px` }}>
                <div className="container">
                    {locale === 'us' && (
                        <div className="paypal">
                            <p className="icon">
                                <PayPalIcon />
                            </p>
                            <p className="desc-tips">
                                <span className="text">Buy now,pay later</span>
                                <Link href="https://www.paypal.com/us/digital-wallet/ways-to-pay/buy-now-pay-later">
                                    Learn More
                                    <span className="arrow-icon">
                                        <EFArrowLeft />
                                    </span>
                                </Link>
                            </p>
                        </div>
                    )}
                    <div className="right">
                        <div className="footer-price">
                            <p className="price">
                                {locale !== 'cn' && (
                                    <span className="total-discount">
                                        {!isPriveReverseFlag && `${data?.selectedPower?.unit} `}
                                        {FormatMoney(Math.round(100 * data?.totalDiscount) / 100, isPriveReverseFlag ? ' ' : ',')}
                                        {isPriveReverseFlag && ` ${data?.selectedPower?.unit}`}
                                        {taxPriceTag[locale] || ''}
                                    </span>
                                )}
                                {locale === 'cn' && <span className="total-discount">{t('calculators.mm100.step4.inquiry')}</span>}
                                {Math.round(100 * data?.totalDiscount) !== Math.round(100 * data?.totalOriginal) && locale !== 'cn' && (
                                    <span className="total-original">
                                        {!isPriveReverseFlag && `${data?.selectedPower?.unit} `}
                                        {FormatMoney(Math.round(100 * data?.totalOriginal) / 100, isPriveReverseFlag ? ' ' : ',')}
                                        {isPriveReverseFlag && ` ${data?.selectedPower?.unit}`}
                                        {taxPriceTag[locale] || ''}
                                    </span>
                                )}
                            </p>
                            {Math.round(100 * data?.totalDiscount) !== Math.round(100 * data?.totalOriginal) && locale !== 'cn' && (
                                <span className="total-price-tag">
                                    {t('calculators.mm100.step4.save')} {!isPriveReverseFlag && `${data?.selectedPower?.unit} `}
                                    {FormatMoney(Math.round(100 * data?.totalOriginal - 100 * data?.totalDiscount) / 100, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${data?.selectedPower?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </span>
                            )}
                        </div>
                        <button className="footer-checkout" onClick={onCheckout} aria-label={t('calculators.mm100.step7.checkout')}>
                            {t('calculators.mm100.step7.checkout')}
                        </button>
                        <span
                            style={{
                                display: 'inline-block',
                                width: 0,
                                height: 0,
                                overflow: 'hidden',
                            }}
                        >
                            {getCartUrl()}
                        </span>
                    </div>
                </div>
            </div>
            {showDetailsModal_CN && (
                <div className="detailsModal_CN">
                    <div className="mask"></div>
                    <div className="modelBox">
                        <span className="close" onClick={() => setShowDetailsModal_CN(false)}>
                            &times;
                        </span>
                        <p className="title">正浩EcoFlow</p>
                        <p className="text">扫描二维码，添加我的企业微信</p>
                        <div className="qrCodeImg">
                            <Image src="/img/common/qrCode_EF.jpg" layout="fill" className="qrCode qrCode_cn" alt="二维码" aria-label="二维码" />
                        </div>
                        <div className="closeBtn" onClick={() => setShowDetailsModal_CN(false)}>
                            关闭
                        </div>
                    </div>
                </div>
            )}
            {installSpecialSites.includes(locale) && (
                <>
                    {showInfoCollection && <InfoCollection cbFunc={collectInfoCb} isCalculator={true} activityId={activityIdMap[locale] || activityIdMap.us} />}
                    {showInfoSuccess && <SuccessDialog isCalculator={true} closeSuccDialog={() => setShowInfoSuccess(false)} />}
                </>
            )}
        </div>
    );
}

const MemoDom = memo(Child);

export default function Step7({ data, callBack }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const staticData = require(`@/data/calculators/mm100/${locale || 'us'}`);
    return <MemoDom data={data} callBack={callBack} staticData={staticData()} />;
}
